import { render } from "./OurTeamPage.vue?vue&type=template&id=8fea61ce&ts=true"
import script from "./OurTeamPage.vue?vue&type=script&lang=ts"
export * from "./OurTeamPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__